import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import type { TaskListTemplateSectionModel } from '@domain-group/realhub-backend-api-types'

import useTaskListTemplateItem from '@hooks/useTaskListTemplateItem'
import useTaskListTemplateItems from '@hooks/useTaskListTemplateItems'

import TaskListTemplateItem from './TaskListTemplateItem'

interface TaskListTemplateSectionProps {
  taskListTemplateSection: TaskListTemplateSectionModel,
}

const TaskListTemplateSection = (props: TaskListTemplateSectionProps) => {
  const { taskListTemplateSection: { id, task_list_template_id, title } } = props

  const taskListTemplateItemsPayload = useTaskListTemplateItems({
    filters: {
      task_list_template_id,
    },
    performHttpRequests: !!task_list_template_id,
  })

  const {
    filteredTaskListTemplateItems,
    hasFilteredTaskListTemplateItems,
    loading,
  } = taskListTemplateItemsPayload

  const taskListTemplateItemPayload = useTaskListTemplateItem({
    task_list_template_id,
    task_list_template_section_id: id,
  })

  const {
    callbacks: { createOrEditTaskListTemplateItem },
  } = taskListTemplateItemPayload

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title={title}>
      <Box flexDirection="column">
        {filteredTaskListTemplateItems.map(taskListTemplateItem => (
          <TaskListTemplateItem key={taskListTemplateItem.id} taskListTemplateItem={taskListTemplateItem} />
        ))}
      </Box>

      <DashboardModule.Footer
        boxProps={{ borderTop: loading || !hasFilteredTaskListTemplateItems ? 'none' : '1px solid' }}
      >
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => createOrEditTaskListTemplateItem()}
          marginLeft="auto"
          // @ts-expect-error TS2322
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Add Checklist Item
        </Button>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default TaskListTemplateSection
